import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';

import styled from 'styled-components';
import { FlexView, Row, Separator } from '@cuemath/comps';

import {
  getAll as getStudentList,
  invalidateList as invalidateStudentList,
} from 'actions/student-list';
import { get as getConfig } from 'actions/configs';

import StudentList from './list';
import Pagination from 'modules/list/pagination';
import Search from 'modules/list/search-bar';

import { RESULTS_PER_PAGE } from 'constants/list';
import { STUDENT_TYPE } from 'constants/form';
import { USER_CONFIG } from 'constants/api';
import { FilterWrapper, FullFlexView } from '../utils/styled-components';

class StudentTab extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      searchKey: null,
      listData: null,
      studentId: null,
      filterParam: null,
    };
  }

  static getDerivedStateFromProps(
    { studentList, students, actions },
    { page, studentId },
  ) {
    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const newState = {};

    newState.listData = store.getAll(studentList, listParams);
    return newState;
  }

  componentDidMount() {
    const { actions, userConfig } = this.props;
    const { page } = this.state;
    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const filterData = {
      page,
      per_page: RESULTS_PER_PAGE,
      student_type: STUDENT_TYPE.STUDENT,
    };

    actions.getStudentList(listParams, filterData);
    if (!userConfig) {
      actions.getConfig(USER_CONFIG);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { actions } = this.props;
    const { page, searchKey, listData, filterParam } = this.state;

    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const filterData = {
      page,
      per_page: RESULTS_PER_PAGE,
      student_type: STUDENT_TYPE.STUDENT,
    };

    if (searchKey) {
      filterData.search = searchKey;
    }

    const isListStale = !!(listData && listData.isStale);

    if (
      prevState.searchKey !== searchKey ||
      prevState.page !== page ||
      filterParam !== prevState.filterParam ||
      isListStale
    ) {
      if (filterParam) {
        filterParam.forEach(filter => {
          let value = filter.value;
          const key = filter.id;

          if (value && Array.isArray(value) && value.length) {
            filterData[key] = value;
          } else {
            if (value !== null) {
              filterData[key] = value;
            }
          }
        });
      }
      actions.getStudentList(listParams, filterData);
    }
  }

  onPageChange = newPage => {
    this.setState({ page: newPage }, () => {});
  };

  onFilter = filters => {
    this.setState({ filterParam: filters });
  };

  onSearch = searchKey => {
    if (searchKey !== this.state.searchKey && (this.state.searchKey || searchKey))
      this.setState({ searchKey: searchKey });
  };

  render() {
    const { page, searchKey, listData } = this.state;

    return (
      <FullFlexView justifyContent="center" alignItems="center">
        <FilterWrapper>
          <Search onSearch={this.onSearch} placeholder="Search Students..." />
        </FilterWrapper>
        <StudentList
          students={!!listData ? listData.data : []}
          searchKey={searchKey}
          onFilter={this.onFilter}
        />
        <Separator transparent height="25" />
        <Pagination
          page={page}
          perPage={RESULTS_PER_PAGE}
          count={null}
          onPageChange={this.onPageChange}
        />
      </FullFlexView>
    );
  }
}

export default withRouter(
  connect(
    ({ studentList, students, configs }) => ({
      studentList,
      students,
      userConfig: store.get(configs, USER_CONFIG),
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getStudentList,
          getConfig,
          invalidateStudentList,
        },
        dispatch,
      ),
    }),
  )(StudentTab),
);
